import { render } from "./RouteHandler.vue?vue&type=template&id=1adfb376"
import script from "./RouteHandler.vue?vue&type=script&lang=js"
export * from "./RouteHandler.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__